import * as FileSaver from 'file-saver';
import { IRenderFunction, ScrollablePane, ScrollbarVisibility, Sticky, StickyPositionType } from 'office-ui-fabric-react';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { CheckboxVisibility, ConstrainMode, DetailsList, DetailsListLayoutMode, IColumn, IDetailsHeaderProps, Selection } from 'office-ui-fabric-react/lib/DetailsList';
import { initializeIcons } from 'office-ui-fabric-react/lib/Icons';
import { ComboBox, Dialog, DialogType, IComboBoxProps } from 'office-ui-fabric-react/lib/index';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { MarqueeSelection } from 'office-ui-fabric-react/lib/MarqueeSelection';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { IStackTokens, Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyles } from 'office-ui-fabric-react/lib/Styling';
import * as React from 'react';
import * as XLSX from 'xlsx';
import { IAgent } from '../../../models/IAgent';
import { IAgentJurisdiction } from '../../../models/IAgentJurisdiction';
import { IAgentProfile } from '../../../models/IAgentProfile';
import { ICountry } from '../../../models/ICountry';
import { IModalDialog } from '../../../models/IModalDialog';
import ConnectionContext from '../../../utils/ConnectionContext';
import AgentProfile from '../AgentProfile/AgentProfile';
import { IAgentListProps } from './IAgentListProps';
import { IAgentListState } from './IAgentListState';
initializeIcons();

export const ExportCSV = ({ csvData, fileName }) => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const exportToCSV = (csvData, fileName) => {
        if (csvData.length > 0) {
            const ws = XLSX.utils.json_to_sheet(csvData);
            const wb = { Sheets: { 'AgentList': ws }, SheetNames: ['AgentList'] };
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const data = new Blob([excelBuffer], { type: fileType });
            FileSaver.saveAs(data, fileName + fileExtension);
        }
    }
    return (
        <PrimaryButton text="Export" onClick={(e) => exportToCSV(csvData, fileName)} className={submitButton} iconProps={{ iconName: "Export" }} />
    )
}
const panel = mergeStyles({
    alignContent: "center",
    display: 'block',
    background: '#ffffff',
    boxShadow: '0px 0px 5px 5px #C9C9C9',
    minHeight: '100px',
    padding: '10px',
    minWidth: '200px',
    fontSize: "13px", color: '#005269'
});
const filterPanel = mergeStyles({ textAlign: "center", paddingBottom: "5px", border: "1px solid #005269", borderRadius: "5px" });
const userMessage = mergeStyles({ fontSize: "13px", fontWeight: "bold", paddingTop: "15px" });
const innerPanel = mergeStyles({ display: "inline-block", margin: "0 auto", width: "auto", color: '#005269', textAlign: "center" });
const textBoxPanel = mergeStyles({ display: "inline-block", verticalAlign: "middle", padding: "5px", fontSize: "13px", margin: "0 auto" });
const listPanel = mergeStyles({ height: '80vh', position: 'relative' });
export interface IDetailsList { key: string; firmName: string; emailId: string; vatregNo: string; firmAddress1: string; firmAddress2: string; city: string; state: string; countryCode: string; countryName: string; postalCode: string; contactPerson: string; phoneNumber: string; serviceJurisdiction: string; }
const getStyles = () => { return { root: { responsiveMode: true, color: '#005269', width: "40%", minWidth: "40%", maxWidth: "100%" } } };
const submitButton = mergeStyles({ backgroundColor: '#73797D', marginRight: "5px" });
export default class AgentList extends React.Component<IAgentListProps, IAgentListState>
{
    private connectionContext: ConnectionContext;
    private selection: Selection;
    private allItems: IDetailsList[];
    private allItemsExcel: IDetailsList[];
    private columns: IColumn[];
    private dialog: IModalDialog;
    private jurisdictionError: string;
    private agentProfile: IAgentProfile[];
    constructor(props: IAgentListProps, state: IAgentListState) {
        super(props);

        this.connectionContext = this.props.connectionContext;
        this.jurisdictionError = '';

        this.selection = new Selection({
            onSelectionChanged: () => this.setState({ selectionDetails: this.getSelectionDetails() })
        });

        this.allItems = [];

        this.columns = [
            {
                key: 'column1', name: 'Agent Name', fieldName: 'firmName', minWidth: 100, maxWidth: 250, isResizable: true,
                onRender: (item: IDetailsList) => (
                    <Link onClick={this.getAgentProfile.bind(this, item)} >{item.firmName}</Link>)
            },
            { key: 'column2', name: 'Email Address', fieldName: 'emailId', minWidth: 100, maxWidth: 150, isResizable: true },
            { key: 'column3', name: 'VatregNo', fieldName: 'vatregNo', minWidth: 100, maxWidth: 100, isResizable: true },
            { key: 'column4', name: 'FirmAddress1', fieldName: 'firmAddress1', minWidth: 100, maxWidth: 100, isResizable: true },
            { key: 'column5', name: 'FirmAddress2', fieldName: 'firmAddress2', minWidth: 100, maxWidth: 100, isResizable: false },
            { key: 'column6', name: 'City', fieldName: 'city', minWidth: 100, maxWidth: 100, isResizable: false },
            { key: 'column7', name: 'CountryName', fieldName: 'countryName', minWidth: 100, maxWidth: 100, isResizable: true },
            { key: 'column8', name: 'ContactPerson', fieldName: 'contactPerson', minWidth: 100, maxWidth: 100, isResizable: true },
            { key: 'column9', name: 'PhoneNumber', fieldName: 'phoneNumber', minWidth: 100, maxWidth: 100, isResizable: true },
            { key: 'column10', name: 'ServiceJurisdiction', fieldName: 'serviceJurisdiction', minWidth: 100, maxWidth: 200, isResizable: true }
        ];
        this.state = {
            loading: false,
            items: this.allItems,
            selectionDetails: this.getSelectionDetails(),
            jurisdictions: [],
            selectedJurisdiction: {
                key: '',
                text: ''
            },
            services: [],
            selectedService: {
                key: '',
                text: ''
            },
            particulars: [],
            selectedParticular: {
                key: '',
                text: ''
            },
            agentId: "",
            hideModel: true
        }
        this.dialog = {
            hideDialog: true,
            accessDeniedDialog: false,
            dialogMessage: '',
            dialogBody: '',
            mode: ''
        }
        this.agentProfile = [];
        this.allItemsExcel = [];
    }
    public async componentDidMount() {
        this.getAgentInfo();
        this.loadCountries();
    }
    private getAgentInfo = async (): Promise<void> => {
        try {
            this.allItems = [];
            this.agentProfile = [];
            let serviceJurisdiction: string = "";
            const value: string = "a";
            let agentlist: IAgent[] = await this.connectionContext.get("Agent");
            this.setState((prevState: IAgentListState): IAgentListState => {
                agentlist.forEach((item: IAgent) => {
                    serviceJurisdiction = "";
                    item.agentJurisdiction.sort((a, b) => a.countryName > b.countryName ? 1 : -1).forEach((agentJurisdiction: IAgentJurisdiction) => {
                        serviceJurisdiction = serviceJurisdiction + agentJurisdiction.countryName + ", ";
                    });
                    serviceJurisdiction = serviceJurisdiction.substr(0, serviceJurisdiction.length - 2);

                    this.allItems.push({
                        key: item.id || "", firmName: item.firmName, firmAddress1: item.firmAddress1, firmAddress2: item.firmAddress2, city: item.city,
                        countryCode: item.countryCode, countryName: item.countryName, contactPerson: item.contactPerson, emailId: item.emailId, phoneNumber: item.phoneNumber,
                        serviceJurisdiction: serviceJurisdiction, vatregNo: item.vatRegNo, state: item.state, postalCode: item.postalCode
                    });

                    this.agentProfile.push({
                        AgentName: item.firmName, VatRegNo: item.vatRegNo, EmailAddress: item.emailId,
                        FirmAddress1: item.firmAddress1, FirmAddress2: item.firmAddress2, City: item.city,
                        State: item.state, CountryCode: item.countryCode, Country: item.countryName, PostalCode: item.postalCode,
                        ContactPerson: item.contactPerson, CPEmailAddress: item.companyEmail, PhoneNumber: item.phoneNumber,
                        ServicesOfferedFor: serviceJurisdiction
                    });

                });
                prevState.items = value ? this.allItems.filter(i => i.firmName.toLowerCase().indexOf(value) > -1 || i.countryName.toLowerCase().indexOf(value) > -1
                    || i.serviceJurisdiction.toLowerCase().indexOf(value) > -1 || i.contactPerson.toLowerCase().indexOf(value) > -1
                    || i.emailId.toLowerCase().indexOf(value) > -1 || i.vatregNo.toLowerCase().indexOf(value) > -1 || i.city.toLowerCase().indexOf(value) > -1) : this.allItems;
                return prevState;
            });
        } catch (e) {
            this.handleError("Timed out", "Your session has expired. Please login again.");
        }
    }
    private loadCountries = async (): Promise<void> => {
        try {
            var result: any = [];
            result.push(
                { key: '', text: '--Select--' });

            let countryList: ICountry[] = await this.props.connectionContext.get("Country");
            this.setState((prevState: IAgentListState): IAgentListState => {
                countryList = countryList.sort((a, b) => a.countryName > b.countryName ? 1 : -1)
                countryList.forEach((item: ICountry) => {
                    result.push(
                        { key: item.countryCode, text: item.countryName })
                });
                prevState.jurisdictions = result;
                return prevState;
            });
        } catch (exception) {
            this.handleError("Timed out", "Your session has expired. Please login again.");
        }
    }
    private getAgentProfile = (item: IDetailsList): void => {
        try {
            this.setState((prevState: IAgentListState): IAgentListState => {
                prevState.agentId = item.key;
                prevState.hideModel = false;
                return prevState;
            });
        } catch (exception) {
            this.handleError("Message", "Unable to process at the moment. Please try again or contact agent.network@zacco.com.");
        }
    }
    public render(): React.ReactElement<IAgentListProps> {
        const stackTokens: IStackTokens = { childrenGap: 20 };
        const { items } = this.state;
        const fileName = "AgentList";
        return (
            <div className={panel}>
                {
                    (!this.state.loading) && (
                        <div>
                            {
                                <div>
                                    <div>
                                        <Dialog
                                            hidden={this.state.hideModel}
                                            dialogContentProps={{
                                                type: DialogType.largeHeader,
                                                title: this.dialog.dialogMessage,
                                            }}
                                            minWidth="80%"
                                            maxWidth="100%"
                                            closeButtonAriaLabel="Ok"
                                        >
                                            <div>
                                                <div>
                                                    <AgentProfile connectionContext={this.connectionContext} agentId={this.state.agentId}
                                                        onClose={this.closeChild} />
                                                </div>
                                            </div>
                                        </Dialog>
                                    </div>
                                </div>
                            }
                            {
                                <div className={filterPanel}>
                                    <div className={innerPanel}>
                                        <div className={textBoxPanel}>
                                            Jurisdiction
                                        </div>
                                        <div className={textBoxPanel}>
                                            <Stack tokens={stackTokens} verticalAlign="end">
                                                <Stack horizontal tokens={stackTokens} verticalAlign="end">
                                                    <ComboBox
                                                        placeholder="Select or type"
                                                        allowFreeform
                                                        autoComplete="on"
                                                        options={this.state.jurisdictions}
                                                        onChange={this.onChangeJurisdiction}
                                                        errorMessage={this.jurisdictionError}
                                                        defaultSelectedKey={this.state.selectedJurisdiction.key ? this.state.selectedJurisdiction.key : undefined}
                                                    />
                                                </Stack>
                                            </Stack>
                                        </div>
                                        <div className={textBoxPanel}>
                                            <PrimaryButton type="submit" value="Search" text="Go" onClick={this.submitForm} className={submitButton} iconProps={{ iconName: "Filter" }} />
                                        </div>
                                        <div className={textBoxPanel}>
                                            <PrimaryButton type="submit" value="Search" text="Refresh" onClick={this.refreshForm} className={submitButton} iconProps={{ iconName: "ClearFilter" }} />
                                        </div>
                                        <div className={textBoxPanel}><ExportCSV csvData={this.agentProfile} fileName={fileName} /></div>
                                    </div>
                                </div>
                            }
                            {
                                <div>
                                    <div className={userMessage}>
                                        Search by a keyword:
                                    </div>
                                    <div>
                                        <SearchBox required placeholder="Search by a keyword" styles={getStyles} onChange={this.onFilter} onSearch={this.onFilter} />
                                    </div>
                                    <div className={userMessage}>
                                        * Click on the agent name to view and download the agent's profile
                                    </div>
                                    <div className={listPanel}>
                                        <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                                            <MarqueeSelection selection={this.selection}>
                                                <DetailsList
                                                    items={items}
                                                    columns={this.columns}
                                                    setKey="set"
                                                    layoutMode={DetailsListLayoutMode.justified}
                                                    selection={this.selection}
                                                    selectionPreservedOnEmptyClick={false}
                                                    ariaLabelForSelectionColumn="Toggle selection"
                                                    ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                                                    checkButtonAriaLabel="Row checkbok"
                                                    onItemInvoked={this.onItemInvoked}
                                                    selectionMode={1}
                                                    compact
                                                    checkboxVisibility={CheckboxVisibility.hidden}
                                                    constrainMode={ConstrainMode.horizontalConstrained}
                                                    isHeaderVisible={true}
                                                    onRenderDetailsHeader={this.onRenderDetailsHeader}
                                                />
                                            </MarqueeSelection>
                                        </ScrollablePane>
                                    </div>
                                </div>
                            }
                        </div>
                    )
                }
            </div>
        );
    }
    private onRenderDetailsHeader: IRenderFunction<IDetailsHeaderProps> = (props, defaultRender) => {
        if (!props) {
            return null;
        }
        return (
            <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced>
                {defaultRender!({
                    ...props
                })}
            </Sticky>
        );
    };
    private onChangeJurisdiction: IComboBoxProps['onChange'] = (event, option): void => {
        this.setState((prevState: IAgentListState): IAgentListState => {
            if (option) {
                prevState.selectedJurisdiction = option;
                this.jurisdictionError = option.text.trim().length > 0 ? '' : 'Required';
            }
            return prevState;
        });
    }
    private submitForm = (): void => {

        const selectedJurisdiction: boolean = this.state.selectedJurisdiction.key.toString().length > 0;
        this.allItemsExcel = [];
        this.agentProfile = [];

        if (selectedJurisdiction) {
            this.setState({
                items: this.allItems.filter(i => i.serviceJurisdiction.indexOf(this.state.selectedJurisdiction.text) > -1 || i.countryName.indexOf(this.state.selectedJurisdiction.text) > -1)
            });
            this.allItemsExcel = this.allItems.filter(i => i.serviceJurisdiction.indexOf(this.state.selectedJurisdiction.text) > -1 || i.countryName.indexOf(this.state.selectedJurisdiction.text) > -1)
        }

        if (!selectedJurisdiction) {
            this.setState({
                items: this.allItems
            });
            this.allItemsExcel = this.allItems;
        }
        this.allItemsExcel.forEach((item: IDetailsList) => {
            this.agentProfile.push({
                AgentName: item.firmName, VatRegNo: item.vatregNo, EmailAddress: item.emailId,
                FirmAddress1: item.firmAddress1, FirmAddress2: item.firmAddress2, City: item.city,
                State: item.state, CountryCode: item.countryCode, Country: item.countryName, PostalCode: item.postalCode,
                ContactPerson: item.contactPerson, CPEmailAddress: item.emailId, PhoneNumber: item.phoneNumber,
                ServicesOfferedFor: item.serviceJurisdiction
            });
        });
        return;
    }
    private refreshForm = (): void => {
        this.getAgentInfo();
        this.loadCountries();
    }
    private getSelectionDetails(): string {
        const selectionCount = this.selection.getSelectedCount();

        switch (selectionCount) {
            case 0:
                return 'No Agent(s) selected';
            case 1:
                return '1 agent selected: ' + (this.selection.getSelection()[0] as IDetailsList).firmName;
            default:
                return `${selectionCount} agents selected`;
        }
    }
    private onFilter = (event?: React.ChangeEvent<HTMLInputElement>, value?: string): void => {
        this.setState({
            items: value ? this.allItems.filter(i => i.firmName.toLowerCase().indexOf(value) > -1 || i.countryName.toLowerCase().indexOf(value) > -1
                || i.serviceJurisdiction.toLowerCase().indexOf(value) > -1 || i.contactPerson.toLowerCase().indexOf(value) > -1
                || i.emailId.toLowerCase().indexOf(value) > -1 || i.vatregNo.toLowerCase().indexOf(value) > -1 || i.city.toLowerCase().indexOf(value) > -1) : this.allItems
        });

        this.allItemsExcel = [];
        this.agentProfile = [];

        this.allItemsExcel = value ? this.allItems.filter(i => i.firmName.toLowerCase().indexOf(value) > -1 || i.countryName.toLowerCase().indexOf(value) > -1
            || i.serviceJurisdiction.toLowerCase().indexOf(value) > -1 || i.contactPerson.toLowerCase().indexOf(value) > -1
            || i.emailId.toLowerCase().indexOf(value) > -1 || i.vatregNo.toLowerCase().indexOf(value) > -1 || i.city.toLowerCase().indexOf(value) > -1) : this.allItems

        this.allItemsExcel.forEach((item: IDetailsList) => {
            this.agentProfile.push({
                AgentName: item.firmName, VatRegNo: item.vatregNo, EmailAddress: item.emailId,
                FirmAddress1: item.firmAddress1, FirmAddress2: item.firmAddress2, City: item.city,
                State: item.state, CountryCode: item.countryCode, Country: item.countryName, PostalCode: item.postalCode,
                ContactPerson: item.contactPerson, CPEmailAddress: item.emailId, PhoneNumber: item.phoneNumber,
                ServicesOfferedFor: item.serviceJurisdiction
            });
        });
    };
    private onItemInvoked = (item: IDetailsList): void => {
        alert(`Agent invoked: ${item.firmName}`);
    };
    private handleError(message: string, body: string) {
        this.dialog.dialogMessage = message;
        this.dialog.dialogBody = body;
        this.dialog.accessDeniedDialog = false;
        this.dialog.hideDialog = false;
        this.setState((previousState: IAgentListState, props: IAgentListProps): IAgentListState => {
            previousState.loading = false;
            return previousState;
        });
    }
    private closeChild = () => {
        this.setState({
            hideModel: true
        });
    }
}